import React from 'react';
import { Search } from '@trussworks/react-uswds';

export function USWDSSearch(props) {
  return <Search {...props} />;
}
